import { evaluate, ValueOrGetter } from "@tylertech/lgd-reactive-forms";

import { Action, Command } from "../interfaces";

import { ForgeButtonType } from "./forgeButtonType";

export interface LabelCommandOptions
{
    readonly label?: ValueOrGetter<string>;
    readonly action?: Action;
    readonly getVisible?: ValueOrGetter<boolean>;
    readonly getEnabled?: ValueOrGetter<boolean>;
    readonly getWaiting?: ValueOrGetter<boolean>;
    readonly tooltip?: ValueOrGetter<string>;
    readonly disabledTooltip?: string;
    readonly tooltipDirection?: string;
    readonly type?: ForgeButtonType;
}

export class LabelCommand implements Command
{
    private readonly _label: ValueOrGetter<string>;
    private readonly _tooltip: ValueOrGetter<string>;
    private readonly getEnabled: ValueOrGetter<boolean>;
    private readonly getVisible: ValueOrGetter<boolean>;
    private readonly getWaiting: ValueOrGetter<boolean>;

    readonly disabledTooltip: string;
    readonly action: Action;
    readonly tooltipDirection?: string;
    readonly type?: ForgeButtonType;


    constructor(options: LabelCommandOptions)
    {
        this._label = options.label;
        this._tooltip = options.tooltip;
        this.disabledTooltip = options.disabledTooltip;
        this.action = options.action;
        this.getEnabled = options.getEnabled;
        this.getVisible = options.getVisible;
        this.getWaiting = options.getWaiting;
        this.tooltipDirection = options.tooltipDirection;
        this.type = options.type;
    }

    get label(): string
    {
        return evaluate(this._label);
    }

    get tooltip(): string
    {
        return this._tooltip
            ? evaluate(this._tooltip)
            : undefined;
    }

    get isVisible(): boolean
    {
        return this.getVisible
            ? evaluate(this.getVisible)
            : true;
    }

    get isEnabled(): boolean
    {
        return this.getEnabled
            ? evaluate(this.getEnabled)
            : true;
    }

    get isWaiting(): boolean
    {
        return this.getWaiting
            ? evaluate(this.getWaiting)
            : false;
    }
}
